import { render } from "./ResetPass.vue?vue&type=template&id=1dafe1e6&scoped=true"
import script from "./ResetPass.vue?vue&type=script&lang=js"
export * from "./ResetPass.vue?vue&type=script&lang=js"

import "./ResetPass.vue?vue&type=style&index=0&id=1dafe1e6&lang=sass&scoped=true"
import "./ResetPass.vue?vue&type=style&index=1&id=1dafe1e6&lang=sass"

import exportComponent from "C:\\yb\\work\\website\\yunyu2021\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dafe1e6"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QInput,QBtn,QIcon});
